<template>
  <g>
    <g clip-path="url(#clip0_15_1204)">
      <path
        d="M12 4.00027V2.21027C12 1.76027 11.46 1.54027 11.15 1.86027L8.35 4.65027C8.15 4.85027 8.15 5.16027 8.35 5.36027L11.14 8.15027C11.46 8.46027 12 8.24027 12 7.79027V6.00027C15.31 6.00027 18 8.69027 18 12.0003C18 12.7903 17.85 13.5603 17.56 14.2503C17.41 14.6103 17.52 15.0203 17.79 15.2903C18.3 15.8003 19.16 15.6203 19.43 14.9503C19.8 14.0403 20 13.0403 20 12.0003C20 7.58027 16.42 4.00027 12 4.00027ZM12 18.0003C8.69 18.0003 6 15.3103 6 12.0003C6 11.2103 6.15 10.4403 6.44 9.75027C6.59 9.39027 6.48 8.98027 6.21 8.71027C5.7 8.20027 4.84 8.38027 4.57 9.05027C4.2 9.96027 4 10.9603 4 12.0003C4 16.4203 7.58 20.0003 12 20.0003V21.7903C12 22.2403 12.54 22.4603 12.85 22.1403L15.64 19.3503C15.84 19.1503 15.84 18.8403 15.64 18.6403L12.85 15.8503C12.54 15.5403 12 15.7603 12 16.2103V18.0003Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_1204">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
